const OWNER = "Lunghe Frequenze APS, Via Canero 14, 24010 Ponteranica (BG), Italia – C.F. 95259900165";
const EMAIL = "info@lunghefrequenze.com";

export const PRIVACY = {
  it: {
    eyebrow: "Informativa",
    lines: ["Privacy e", "Cookie Policy."],
    intro: "Come trattiamo i dati di chi visita questo sito, ai sensi del Regolamento UE 2016/679 (GDPR) e delle Linee guida cookie del Garante Privacy.",
    updated: "Ultimo aggiornamento: 10 ottobre 2026",
    storageTitle: "Strumenti tecnici utilizzati",
    storageHead: ["Nome", "Tipo", "Finalità", "Durata"],
    storage: [
      ["lf-lang", "localStorage", "Ricorda la lingua scelta (IT/EN)", "Fino alla cancellazione"],
      ["lf-cookie-notice", "localStorage", "Ricorda che hai chiuso l'avviso cookie", "Fino alla cancellazione"],
      ["lf-intro", "sessionStorage", "Mostra l'animazione d'ingresso una sola volta", "Fino alla chiusura del browser"],
    ],
    sections: [
      { h: "Titolare del trattamento", p: [`${OWNER}. Contatto: ${EMAIL}.`] },
      {
        h: "Dati trattati",
        p: [
          "Dati di navigazione: i sistemi che fanno funzionare il sito raccolgono automaticamente alcuni dati tecnici (ad es. indirizzo IP, tipo di browser, orario della richiesta) necessari al funzionamento e alla sicurezza del servizio.",
          `Dati forniti volontariamente: se ci scrivi a ${EMAIL}, useremo il tuo indirizzo e le informazioni che ci invii solo per risponderti e gestire la tua richiesta.`,
          "Il sito non contiene moduli di registrazione e non raccoglie altri dati personali.",
        ],
      },
      {
        h: "Base giuridica e finalità",
        p: [
          "I dati di navigazione sono trattati per il legittimo interesse al corretto funzionamento e alla sicurezza del sito (art. 6.1.f GDPR). I dati inviati via email sono trattati per rispondere alle tue richieste (art. 6.1.b GDPR).",
        ],
      },
      {
        h: "Cookie",
        p: [
          "Questo sito non usa cookie di profilazione, pubblicità o statistiche di terze parti. Utilizza soltanto gli strumenti tecnici elencati nella tabella, salvati nel tuo browser, necessari a ricordare le tue preferenze. Per questi strumenti non è richiesto il consenso.",
          "Puoi cancellarli in qualsiasi momento dalle impostazioni del tuo browser (cancellazione dei dati dei siti).",
        ],
      },
      {
        h: "Link esterni",
        p: ["Il sito contiene link a servizi esterni (es. Instagram e il nostro blog). Una volta aperti, si applicano le informative privacy di quei servizi."],
      },
      {
        h: "Conservazione e destinatari",
        p: [
          "I dati sono conservati per il tempo necessario alle finalità indicate. Possono essere trattati dai fornitori tecnici che ospitano il sito e la posta elettronica, in qualità di responsabili del trattamento. I dati non vengono venduti né ceduti a terzi.",
        ],
      },
      {
        h: "I tuoi diritti",
        p: [
          `Puoi chiedere in qualsiasi momento accesso, rettifica, cancellazione, limitazione od opposizione al trattamento e la portabilità dei tuoi dati (artt. 15–22 GDPR), scrivendo a ${EMAIL}.`,
          "Hai inoltre il diritto di proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
        ],
      },
    ],
    notice: "Questo sito usa solo strumenti tecnici per ricordare le tue preferenze, nessun cookie di profilazione.",
    noticeOk: "Ho capito",
    noticeMore: "Leggi l'informativa",
    footerLink: "Privacy e Cookie Policy",
  },
  en: {
    eyebrow: "Notice",
    lines: ["Privacy and", "Cookie Policy."],
    intro: "How we process the data of visitors to this website, under EU Regulation 2016/679 (GDPR) and the Italian Data Protection Authority's cookie guidelines.",
    updated: "Last updated: 10 October 2026",
    storageTitle: "Technical tools used",
    storageHead: ["Name", "Type", "Purpose", "Duration"],
    storage: [
      ["lf-lang", "localStorage", "Remembers the chosen language (IT/EN)", "Until deleted"],
      ["lf-cookie-notice", "localStorage", "Remembers that you closed the cookie notice", "Until deleted"],
      ["lf-intro", "sessionStorage", "Shows the intro animation only once", "Until the browser is closed"],
    ],
    sections: [
      { h: "Data controller", p: [`${OWNER}. Contact: ${EMAIL}.`] },
      {
        h: "Data we process",
        p: [
          "Browsing data: the systems running the website automatically collect some technical data (e.g. IP address, browser type, time of request) needed for the service to work and stay secure.",
          `Data you provide: if you write to ${EMAIL}, we will use your address and the information you send only to reply and handle your request.`,
          "The website has no registration forms and does not collect any other personal data.",
        ],
      },
      {
        h: "Legal basis and purposes",
        p: [
          "Browsing data is processed on the basis of our legitimate interest in the proper functioning and security of the website (Art. 6.1.f GDPR). Data sent by email is processed to reply to your requests (Art. 6.1.b GDPR).",
        ],
      },
      {
        h: "Cookies",
        p: [
          "This website does not use profiling, advertising or third-party analytics cookies. It only uses the technical tools listed in the table, stored in your browser, to remember your preferences. No consent is required for these tools.",
          "You can delete them at any time from your browser settings (clear site data).",
        ],
      },
      {
        h: "External links",
        p: ["The website contains links to external services (e.g. Instagram and our blog). Once opened, the privacy policies of those services apply."],
      },
      {
        h: "Retention and recipients",
        p: [
          "Data is kept for as long as needed for the purposes stated. It may be processed by the technical providers hosting the website and email, acting as data processors. Data is never sold or transferred to third parties.",
        ],
      },
      {
        h: "Your rights",
        p: [
          `You can request access, rectification, erasure, restriction of or objection to processing, and data portability at any time (Arts. 15–22 GDPR) by writing to ${EMAIL}.`,
          "You also have the right to lodge a complaint with the Italian Data Protection Authority (www.garanteprivacy.it).",
        ],
      },
    ],
    notice: "This website only uses technical tools to remember your preferences, no profiling cookies.",
    noticeOk: "Got it",
    noticeMore: "Read the policy",
    footerLink: "Privacy and Cookie Policy",
  },
};
